import React from 'react';
import { Redirect } from 'react-router';
import { Route, Switch } from 'react-router-dom';
import { getLegacyRedirects } from './legacy_redirects';

import {
  TrackedFrontPage,
  // TrackedMaleFrontPage,
  // TrackedFemaleFrontPage,
  TrackedSignUpPage,
  TrackedLoginPage,
  TrackedMagicLinkCallbackPage,
  TrackedForgotPasswordPage,
  TrackedLogOutDispatcher,
  TrackedUserProfile,
  TrackedMyOrdersPage,
  TrackedMyTicketsPage,
  TrackedExperienceCatalogPage,
  TrackedExperienceDetailPage,
  TrackedSingleItemPage,
  TrackedHowItWorksPage,
  TrackedNYE20232024Page,
  TrackedCartPage,
  TrackedFavoritesPage,
  TrackedPrecheckoutPage,
  TrackedCheckoutPage,
  TrackedSuccessfulCheckoutPage,
  TrackedFailedCheckoutPage,
  TrackedCanceledCheckoutPage,
  TrackedStripeVerificationPage,
  TrackedTabbyVerificationPage,
  TrackedSellerStoryPage,
  TrackedSpecificLFClipPage,
  TrackedAllSellersPage,
  TrackedEmailVerificationPage,
  TrackedChangeEmailPage,
  TrackedMyPhoneNumbersPage,
  TrackedPasswordResetVerdictPage,
  TrackedPasswordResetter,
  TrackedMenShoppingPage,
  TrackedWomenShoppingPage,
  TrackedKidsShoppingPage,
  TrackedTermsOfService,
  TrackedPrivacyPolicy,
  TrackedDeliveryPolicy,
  TrackedContactUsPage,
  TrackedSubscribePage,
  TrackedAboutUsPage,
  TrackedPageNotFound,
  TrackedSearchResultPage,
  TrackedCookiesPolicy,
  TrackedCaliforniaConsumerPrivacyActDisclosurePage,
  TrackedAppDownloadPage,
  TrackedAppBetaEnrollmentPage,
  TrackedArticlePage,
  TrackedSellerApplicationPage,
  TrackedReturnPolicy,
  TrackedReturnPoliciesPage,
  TrackedDeliveryPoliciesPage,
  TrackedLiveStreamsPage,
  TrackedDiscoverPage,
  TrackedKidsDiscoverPage,
  TrackedWomenDiscoverPage,
  TrackedMenDiscoverPage,
  TrackedShoppingFiltersPage,
  TrackerProfilePreviewPage,
  TrackedCreatorsPage
} from './tracked_pages';

const AppRoutes = () => (
  <Switch>
    <Route exact path='/return-policies/:slug' component={TrackedReturnPoliciesPage} />
    <Route exact path='/delivery-policies/:slug' component={TrackedDeliveryPoliciesPage} />
    <Route exact path='/login' component={TrackedLoginPage} />
    <Route exact path='/magic_link/callback' component={TrackedMagicLinkCallbackPage} />
    <Route exact path='/sign-up' component={TrackedSignUpPage} />
    <Route exact path='/login/r/:encodedRedirect' component={TrackedLoginPage} />
    <Route exact path='/sign-up/r/:encodedRedirect' component={TrackedSignUpPage} />
    <Route exact path='/logout' component={TrackedLogOutDispatcher} />
    <Route exact path='/return-policy' component={TrackedReturnPolicy} />
    <Route exact path='/delivery-policy' component={TrackedDeliveryPolicy} />
    <Route exact path='/cookies' component={TrackedCookiesPolicy} />
    <Route exact path='/california-consumer-privacy-act-disclosure'
      component={TrackedCaliforniaConsumerPrivacyActDisclosurePage} />
    <Route exact path='/tos' component={TrackedTermsOfService} />
    <Route exact path='/privacy' component={TrackedPrivacyPolicy} />
    <Route exact path='/contact' component={TrackedContactUsPage} />
    <Route exact path='/about-us' component={TrackedAboutUsPage} />
    <Route exact path='/subscribe' component={TrackedSubscribePage} />
    <Route exact path='/how-it-works' component={TrackedHowItWorksPage} />
    <Redirect exact from='/measure-me' to='/how-it-works' />

    <Route exact path='/sellers' component={TrackedAllSellersPage} />

    <Route exact path='/profile' component={TrackedUserProfile} />
    <Route exact path='/orders/:id' component={TrackedMyOrdersPage} />
    <Route exact path='/orders' component={TrackedMyOrdersPage} />
    <Route exact path='/tickets' component={TrackedMyTicketsPage} />
    <Route exact path='/events' component={TrackedExperienceCatalogPage} />
    <Route exact path='/events/:slug' component={TrackedExperienceDetailPage} />

    <Route exact path='/men/:filter' component={TrackedMenShoppingPage} />
    <Route exact path='/women/:filter' component={TrackedWomenShoppingPage} />
    <Route exact path='/kids/:filter' component={TrackedKidsShoppingPage} />
    <Route exact path='/shop/:filter' component={TrackedShoppingFiltersPage} />

    <Route exact path='/search' component={TrackedSearchResultPage} />

    {getLegacyRedirects().map(redirect =>
      <Redirect exact from={redirect.from} to={redirect.to} key={redirect.key} />)}

    <Route exact path='/shopping/:slug' component={TrackedSingleItemPage} />
    <Route exact path='/seller/:slug' component={TrackedSellerStoryPage} />

    <Route exact path='/lfclips/:id' component={TrackedSpecificLFClipPage} />
    <Route exact path='/v/:id' component={TrackedSpecificLFClipPage} />

    <Route exact path='/live-streams' component={TrackedLiveStreamsPage} />
    <Route exact path='/live-stream/:id' component={TrackedLiveStreamsPage} />

    <Route exact path='/verify-email' component={TrackedEmailVerificationPage} />
    <Route exact path='/change-email' component={TrackedChangeEmailPage} />
    <Route exact path='/my-phone-numbers' component={TrackedMyPhoneNumbersPage} />

    <Route exact path='/reset-password/:code' component={TrackedPasswordResetter} />
    <Route exact path='/password-reset/:verdict' component={TrackedPasswordResetVerdictPage} />
    <Route exact path='/cart' component={TrackedCartPage} />
    <Route exact path='/favorites' component={TrackedFavoritesPage} />
    <Route exact path='/forgot-password' component={TrackedForgotPasswordPage} />
    <Route exact path='/precheckout' component={TrackedPrecheckoutPage} />
    <Route exact path='/checkout' component={TrackedCheckoutPage} />
    <Route exact path='/thank-you' component={TrackedSuccessfulCheckoutPage} />
    <Route exact path='/payment-failed' component={TrackedFailedCheckoutPage} />
    <Route exact path='/payment-canceled' component={TrackedCanceledCheckoutPage} />
    <Route exact path='/stripe-verification' component={TrackedStripeVerificationPage} />
    <Route exact path='/tabby-verification' component={TrackedTabbyVerificationPage} />

    <Route exact path='/nye-2023-2024' component={TrackedNYE20232024Page} />

    <Route exact path='/men-home' component={TrackedDiscoverPage} />
    <Route exact path='/women-home' component={TrackedDiscoverPage} />
    <Route exact path='/kids-home' component={TrackedKidsDiscoverPage} />
    <Route exact path='/discover' component={TrackedDiscoverPage} />
    <Route exact path='/discover-women' component={TrackedWomenDiscoverPage} />
    <Route exact path='/discover-men' component={TrackedMenDiscoverPage} />
    <Route exact path='/get-the-app' component={TrackedAppDownloadPage} />
    <Route exact path='/u/:key' component={TrackerProfilePreviewPage} />
    <Route exact path='/uid/:key' component={TrackerProfilePreviewPage} />
    <Route exact path='/p/:key' component={TrackedAppDownloadPage} />
    <Route exact path='/enroll-beta/:key' component={TrackedAppBetaEnrollmentPage} />
    <Route exact path='/beta-enroll/:key' component={TrackedAppBetaEnrollmentPage} />
    <Route exact path='/creators' component={TrackedCreatorsPage} />

    <Route exact path='/articles/:slug' component={TrackedArticlePage} />
    <Redirect exact from='/seller-form' to='/seller-application' />
    <Route exact path='/seller-application' component={TrackedSellerApplicationPage} />

    <Redirect exact from='/home/men' to='/discover' />
    <Redirect exact from='/home/women' to='/discover' />
    <Redirect exact from='/home/kids' to='/kids-home' />
    <Redirect exact from='/discover-kids' to='/kids-home' />
    <Redirect exact from='/discover-page' to='/discover' />

    <Route exact path='/' component={TrackedFrontPage} />
    <Route component={TrackedPageNotFound} />
  </Switch>);

export default AppRoutes;
